/**
 * @generated SignedSource<<87c4af76f66aa7b3b440a563b00c2ef4>>
 * @relayHash 7a8283bfbb61d0d92635f5afae27a2f7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8b2c5d8a160bb67e0dc08c2d13b3a126ae17e7d8bc548d59da1d5e3f41d8643b

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LookAndFeelPageQuery$variables = {
  cloudId: string;
};
export type LookAndFeelPageQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"DateTimeSection_jiraQuery" | "NavColorSection_jiraQuery" | "TitleSection_jiraQuery">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"FaviconSection_query" | "LogoSection_query">;
};
export type LookAndFeelPageQuery = {
  response: LookAndFeelPageQuery$data;
  variables: LookAndFeelPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "kind": "ScalarField",
    "name": "isCustom"
  },
  {
    "kind": "ScalarField",
    "name": "path"
  }
],
v4 = [
  {
    "kind": "ScalarField",
    "name": "value"
  },
  {
    "kind": "ScalarField",
    "name": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LookAndFeelPageQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "FragmentSpread",
        "name": "LogoSection_query"
      },
      {
        "args": (v2/*: any*/),
        "kind": "FragmentSpread",
        "name": "FaviconSection_query"
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v2/*: any*/),
              "kind": "FragmentSpread",
              "name": "TitleSection_jiraQuery"
            },
            {
              "args": (v2/*: any*/),
              "kind": "FragmentSpread",
              "name": "NavColorSection_jiraQuery"
            },
            {
              "args": (v2/*: any*/),
              "kind": "FragmentSpread",
              "name": "DateTimeSection_jiraQuery"
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LookAndFeelPageQuery",
    "selections": [
      {
        "alias": "LogoSectionLogo",
        "args": (v2/*: any*/),
        "concreteType": "JiraLookAndFeel",
        "kind": "LinkedField",
        "name": "jira_lookAndFeel",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraLogo",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": (v3/*: any*/)
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "FaviconSectionProjectIconProperty",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "keys",
                "value": [
                  "jira.favicon.use.projecticon"
                ]
              }
            ],
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": (v4/*: any*/)
          },
          {
            "alias": "TitleSectionProperty",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "keys",
                "value": [
                  "jira.lf.logo.show.application.title"
                ]
              }
            ],
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": (v4/*: any*/)
          },
          {
            "alias": "NavColorSectionBackgroundColorProperty",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "keys",
                "value": [
                  "jira.lf.navigation.bgcolour"
                ]
              }
            ],
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": (v4/*: any*/)
          },
          {
            "alias": "NavColorSectionHighlightColorProperty",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "keys",
                "value": [
                  "jira.lf.navigation.highlightcolour"
                ]
              }
            ],
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": (v4/*: any*/)
          },
          {
            "alias": "DateTimeSectionTimeFormat",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "keys",
                "value": [
                  "jira.lf.date.time"
                ]
              }
            ],
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": (v4/*: any*/)
          },
          {
            "alias": "DateTimeSectionDayFormat",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "keys",
                "value": [
                  "jira.lf.date.day"
                ]
              }
            ],
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": (v4/*: any*/)
          },
          {
            "alias": "DateTimeSectionCompleteFormat",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "keys",
                "value": [
                  "jira.lf.date.complete"
                ]
              }
            ],
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": (v4/*: any*/)
          },
          {
            "alias": "DateTimeSectionDateFormat",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "keys",
                "value": [
                  "jira.lf.date.dmy"
                ]
              }
            ],
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": (v4/*: any*/)
          },
          {
            "alias": "DateTimeSectionUseIso8601",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "keys",
                "value": [
                  "jira.date.time.picker.use.iso8061"
                ]
              }
            ],
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": (v4/*: any*/)
          }
        ]
      },
      {
        "alias": "FaviconSectionFavicon",
        "args": (v2/*: any*/),
        "concreteType": "JiraLookAndFeel",
        "kind": "LinkedField",
        "name": "jira_lookAndFeel",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraFavicon",
            "kind": "LinkedField",
            "name": "favicon",
            "plural": false,
            "selections": (v3/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8b2c5d8a160bb67e0dc08c2d13b3a126ae17e7d8bc548d59da1d5e3f41d8643b",
    "metadata": {},
    "name": "LookAndFeelPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d8417e64a6e2a995d4d390f3b7cc566e";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
